import environmentVariables from '../environment'

export function logger(
  logLevel: 'warn' | 'info' | 'error' | 'log',
  ...args: unknown[]
): void {
  const logLevelWarnOrError = logLevel === 'warn' || logLevel === 'error'

  if (
    environmentVariables.REACT_APP_ENV !== 'prod' &&
    (environmentVariables.DEBUG_LOG === 'true' || logLevelWarnOrError)
  ) {
    // eslint-disable-next-line no-console
    console[logLevel](...args)
  }
}
